import { render } from "./PolicyTracking.vue?vue&type=template&id=5d915dca&scoped=true"
import script from "./PolicyTracking.vue?vue&type=script&lang=js"
export * from "./PolicyTracking.vue?vue&type=script&lang=js"

import "./PolicyTracking.vue?vue&type=style&index=0&id=5d915dca&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d915dca"]])

export default __exports__